<h2 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Configure Form Grid
</h2>
<mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="Configure Columns">
            <div class="block">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Form Open Button Position</mat-label>
                    <mat-select name="commandColumnPostion" [(value)]="CommandColumnPostion">
                        <mat-option [value]="'left'">Left</mat-option>
                        <mat-option [value]="'right'">Right</mat-option>
                    </mat-select>
                </mat-form-field>
                <div><small>Should the "Open" button on each row be on the left or right?</small></div>
            </div>

            <h5>Form & Metadata Fields</h5>
            <div class="form-template-properties-div">
                <kendo-grid [kendoGridBinding]="this.AllSelectableFields"
                            (cellClick)="handleCellClick($event)"
                            (cellClose)="handlePropertiesChange($event)"
                            [selectable]="SelectionSettings"
                            kendoGridSelectBy
                            [(selectedKeys)]="IndexesOfSelectedMetaDataAndFormLevelFields"
                            [rowReorderable]="true"
                            (rowReorder)="handleRowReorder($event)">
                    <kendo-grid-rowreorder-column [width]="7"></kendo-grid-rowreorder-column>
                    <kendo-grid-column field="propertyName" title="Property Name" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="alias" title="Property Alias" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="columnWidth" title="Column Width" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="optionalFilterValue" title="Optional Filter Value" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="optionalAggregateNames" title="Optional Aggregator(s)" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="associatedFlexFieldName" title="Associated Flex Fields" [width]="50"></kendo-grid-column>
                    <kendo-grid-checkbox-column [showSelectAll]="true" [width]="10"></kendo-grid-checkbox-column>
                </kendo-grid>
            </div>

            <div *ngIf="Grids.length > 0" style="width:100%;" class="block">
                <h5>Selected Grid</h5>
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Grid</mat-label>

                    <mat-select name="selectedGridFieldId"
                                class="wide"
                                [disabled]="false"
                                [(value)]="SelectedGridFieldId"
                                (selectionChange)="this.handleGridSelection($event)">
                        <mat-option [value]="0">--- No Grid Selected ---</mat-option>

                        <mat-option *ngFor="let f of Grids" [value]="f.fieldId">
                            {{f.propertyName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <kendo-grid *ngIf="SelectedGridFieldId"
                            [kendoGridBinding]="this.GridlevelFormFields"
                            (cellClick)="handleCellClick($event)"
                            (cellClose)="handlePropertiesChange($event)"
                            [selectable]="SelectionSettings"
                            kendoGridSelectBy
                            [(selectedKeys)]="IndexesOfSelectedGridFields"
                            [rowReorderable]="true"
                            (rowReorder)="handleRowReorder($event)">
                    <kendo-grid-rowreorder-column [width]=7></kendo-grid-rowreorder-column>
                    <kendo-grid-column field="propertyName" title="Property Name" width=50></kendo-grid-column>
                    <kendo-grid-column field="alias" title="Property Alias" width=50></kendo-grid-column>
                    <kendo-grid-column field="columnWidth" title="Column Width" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="optionalFilterValue" title="Optional Filter Value" width=50></kendo-grid-column>
                    <kendo-grid-column field="associatedFlexFieldName" title="Associated Flex Fields" [width]="50"></kendo-grid-column>
                    <kendo-grid-checkbox-column [showSelectAll]="true" [width]="10"></kendo-grid-checkbox-column>
                </kendo-grid>
                <div><small>Select a Grid in order to choose column from it to appear in the Form Grid</small></div>
            </div>
        </mat-tab>

        <mat-tab label="Configure Action Buttons">
            <kendo-grid [kendoGridBinding]="this.ActionButtons"
                        [selectable]="SelectionSettings"
                        (cellClick)="handleActionButtonCellClick($event)"
                        (cellClose)="handleActionButtonCellChange($event)"
                        kendoGridSelectBy
                        [(selectedKeys)]="IndexesOfSelectedActionButtons">
                <kendo-grid-column field="buttonDisplayName" title="Display Name" [width]=50></kendo-grid-column>
                <kendo-grid-column field="alias" title="Alias" [width]=50></kendo-grid-column>
                <kendo-grid-checkbox-column [showSelectAll]="true" [width]="10"></kendo-grid-checkbox-column>
            </kendo-grid>
            <!--
                <div *ngFor="let buttonInfo of this.FormTemplateButtonInfo">
                    <mat-checkbox [(ngModel)]="buttonInfo.enableButton"
                                  style="margin-left: 15px;">{{buttonInfo.buttonDisplayName}}</mat-checkbox>
                </div>
            -->
            <small>Toolbar buttons to enable</small>
        </mat-tab>
    </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-flat-button color="primary" class="theme-primary-btn" (click)="closeDialog(true)">
        OK
    </button>

    <button mat-flat-button (click)="closeDialog()">
        Cancel
    </button>
</mat-dialog-actions>
